import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const baseUrlApi = createApi({
  baseQuery: fetchBaseQuery({ 
    baseUrl: process.env.NEXT_PUBLIC_NEXT_API
  }),
  endpoints: () => ({}),
});